export const colorMaps = (item, settings) => {
  if (item > 0 && item <= 2.5) return settings.red;
  else if (item > 2.5 && item <= 5) return settings.orange;
  else if (item > 5 && item <= 7.5) return settings.yellow;
  else if (item > 7.5 && item <= 10) return settings.green;
};
